/* @flow */

const quoteRoutes: Array<*> = [];

export default quoteRoutes;
